import React from "react";
import { Space, Table, Tag } from "antd";
import TableColumnLoader from "../../../components/loader/TableColumnLoader";
import SearchInput from "../../../components/utils/SearchInput";
import {
  dateFormatterUI6,
  stringSorter,
} from "../../../utils/helpers/dataHelper";

const AntTable = ({
  eventList,
  handleApproval,
  statusState,
  handleView,
  handleSearch,
  handleCreate,
}) => {
  const columns = [
    {
      title: "Creator",
      // fixed: "left",
      key: "1",
      render: (record) => (
        <div className="pl-0">
          <div className="text-base font-semibold">
            {record.creator.fullName}
          </div>
          <div className="font-normal text-gray-500">
            {record.creator.emailAddress}
          </div>
        </div>
      ),
    },
    {
      title: "Event Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: " Event Date",
      dataIndex: "eventDate",
      key: "eventDate",
      render: (eventDate) => <span>{dateFormatterUI6(eventDate)}</span>,
      sorter: (a, b) => stringSorter(a.createdDate, b.createdDate),
    },
    {
      title: " No. of Attendees",
      dataIndex: "noOfAttendees",
      key: "noOfAttendees",
    },
    {
      title: "Category",
      key: "eventCategory",
      dataIndex: "eventCategory",
      render: (eventCategory) => (
        <span>
          <Tag color={"blue"} key={eventCategory}>
            {eventCategory}
          </Tag>
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      // fixed: "right",
      render: (_, record) => (
        <Space size="middle">
          {statusState[record.id] ? (
            <TableColumnLoader />
          ) : (
            <>
              {record.approved ? (
                <Tag
                  color={"green"}
                  className="cursor-pointer"
                  onClick={() => handleApproval(record)}
                >
                  Disapprove
                </Tag>
              ) : (
                <Tag
                  color={"red"}
                  className="cursor-pointer"
                  onClick={() => handleApproval(record)}
                >
                  Approve
                </Tag>
              )}
            </>
          )}

          <Tag
            color={"blue"}
            className="cursor-pointer"
            onClick={() => handleView(record)}
          >
            View
          </Tag>
        </Space>
      ),
    },
  ];
  return (
    <div>
      <div className="flex justify-between items-center py-4 bg-white dark:bg-gray-800">
        <div>
          <button
            className="bg-green-800 text-white rounded-md p-2 px-4"
            onClick={() => handleCreate()}
          >
            Create
          </button>
        </div>
        <SearchInput handleSearch={(value) => handleSearch(value)} />
      </div>
      <Table
        columns={columns}
        pagination={{}}
        dataSource={eventList}
        scroll={{
          x: 1500,
        }}
        sticky
      />
    </div>
  );
};

export default AntTable;
